<template>
  <modal
      id="crm-list-modal"
      size="large"
      v-model="showModal"
      :title="from === 'user' ? generateModalTitle('user') : generateModalTitle('Header')"
      @submit="submit"
      :loading="loading"
      :btn-label="selectedUrl ? $t('save') : $t('add')"
      :preloader="preloader">

    <form
        v-if="(isMailSettingExist || selectedUrl) && !preloader"
        ref="form"
        method="post"
        enctype="multipart/form-data"
        :data-url='selectedUrl ? CRM_HEADER : CRM_HEADER'
        @submit.prevent="submitData"
    >
      <div class="row">
        <div class="col-md-12">
          <app-form-group
              type="text"
              :label="$t('prescript_title')"
              v-model="formData.prescript_title"
              :error-message="$errorMessage(errors, 'prescript_title')"
          />
          <app-form-group
              type="text"
              :label="$t('title')"
              v-model="formData.title"
              :error-message="$errorMessage(errors, 'title')"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <app-input
              type="text-editor"
              v-model="formData.description"
              v-if="!loading"
              id="description"
              :placeholder="$textAreaPlaceHolder('description')"
              row="5"
              :error-message="$errorMessage(errors, 'custom_content')"
              :text-editor-hints="textEditorHints(Object.keys(tags))"
          />
          <small v-if="$errorMessage(errors, 'description')" class="text-danger">
              {{ $errorMessage(errors, 'description') }}
          </small>
        </div>
        <div class="col-md-12">
          <div class="row my-4">
            <div class="col-md-12 col-lg-12">
              <app-form-group
                  :label="$fieldLabel('cms', 'Image')"
                  page="page"
                  type="file"
                  v-model="formData.image"
                  :error-message="$errorMessage(errors, 'image')"
                  :file-label="$fieldLabel('cms', 'Image')"
              />
            </div>
          </div>
        </div>
      </div>

    </form>

    <template v-if="!isMailSettingExist && !selectedUrl" slot="footer">
      <button type="button"
              class="btn btn-secondary"
              data-dismiss="modal">
        {{ $t('close') }}
      </button>
    </template>
  </modal>
</template>

<script>
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import {
  CRM_HEADER, GET_CRM_HEADER,
} from "../../../Config/ApiUrl";
import {
  TENANT_MAIL_CHECK_URL,
} from "../../../../common/Config/apiUrl";
import {axiosGet, axiosPost, urlGenerator} from "../../../../common/Helper/AxiosHelper";
import LogMixin from "../../Mixins/LogMixin";
import {textEditorHints} from "../../../../common/Helper/Support/TextEditorHelper";
import {crmTag} from "../../../../common/Components/Settings/Common/http/NotificationTemplate/Helper";
import TemplateMixins from "../../../../common/Components/Settings/Common/http/NotificationTemplate/TemplateMixins";

export default {
  name: "CRMCreateEditModal",
  mixins: [FormHelperMixins, ModalMixin, LogMixin, TemplateMixins],
  props: {
    from: {
      type: String,
      default: 'crm'
    },
    loaderColor: {
      type: String,
      default: 'white-color'
    }
  },
  data() {
    return {
      textEditorHints,
      tags: crmTag(),
      maps: null,
      isMailSettingExist: true,
      preloader: false,
      loading: false,
      formData: {
        prescript_title: "",
        title: "",
        description: "",
        image: ""
      },
      CRM_HEADER,
      GET_CRM_HEADER,
    }
  },
  methods: {
    handleFileUpload(event) {
      this.formData.image = event.target.files[0];
    },
    async submit() {
      this.fieldStatus.isSubmit = true;
      this.loading = true;
      this.message = '';
      this.errors = {};

      await this.uploadImage(this.formData);
      this.submitData(this.formData);
    },
    async uploadImage(event) {
      const file = event.image;
      const formData = new FormData();
      formData.append('image', file);

      try {
        const response = await axios.post('/admin/crm/section/image', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        this.formData.image = response.data.url;
      } catch (error) {
        console.error("There was an error uploading the image", error);
      }
    },
    afterSuccess({data}) {
      this.formData = {};
      $('#crm-list-modal').modal('hide');
      this.$emit('input', false);
      this.toastAndReload(data.message, this.from === 'crm' ? 'crm-table' : 'user-table');
      if (this.from === 'user') {
        this.$hub.$emit(`reload-role-table`)
      }
      else {
        this.$hub.$emit(`reload-crm-table`)
      }
    },
    afterSuccessFromGetEditData({data}) {
      this.preloader = false;
      console.log(this.selectedUrl);
      //Before customization this was "  this.formData = data;"
      this.formData = {...this.formData, ...data};
    },
    generateModalTitle(subject) {
      return this.$fieldTitle(this.selectedUrl ? 'edit' : 'edit', subject, true);
    },
  },
  created() {
  },
  computed: {},
  mounted() {
  },
  watch: {
    'formData.image': {
      handler: function () {
        // this.formData.image = this.formData.image ? urlGenerator(this.formData.image) : urlGenerator('/images/core.png');
      }
    }
  }
}
</script>